<form #f="ngForm" style="width: 100%;">
  <div class="grid fluid">
    <div class="col-12">
      <div class="field-label" i18n="@@viewer-splitter-specify-page">The document will be split after the end of page:</div>
      <p-inputNumber [(ngModel)]="detail.splitAfterPageNumber" name="splitAfterPageNumber"
                     class="acted-highlight-req form-field" [required]="true" [min]="1">
      </p-inputNumber>
    </div>

    <div class="col-12">
      <div class="field-label" i18n="@@viewer-splitter-specify-name">Specify a name to identify the new document:</div>
      <input pInputText type="text" [(ngModel)]="detail.newName" name="newName"
             class="acted-highlight-req form-field" [required]="true"/>
    </div>

    <div class="col-12 text-right">
      <p-button icon="fa fa-solid fa-xmark" label="Cancel" i18n-label="@@common-cancel" (onClick)="onCancel()" severity="secondary"></p-button>
      <p-button icon="fa fa-regular fa-floppy-disk" label="Split" i18n-label="@@viewer-splitter-split" (onClick)="onSubmit()"
                [disabled]="!f.valid" class="ml-1"></p-button>
    </div>
  </div>
</form>
